import type { IPricingComparisonFeatureForPlan } from '../../types';

import { BlockStack, Icon, Text } from '@shopify/polaris';
import { PlanCompareTable } from './PlanCompareTable';

export const PlanDetailItem = ({ detail }: { detail: IPricingComparisonFeatureForPlan }) => {
  return (
    <PlanCompareTable.Cell>
      <BlockStack gap="200">
        {detail?.descriptions && (
          <BlockStack gap="100">
            {detail.descriptions.map((description, index) => (
              <Text key={index} as="p" variant="bodyMd">
                {description.content}
              </Text>
            ))}
          </BlockStack>
        )}

        {detail?.iconProps && <Icon {...detail.iconProps} />}
      </BlockStack>
    </PlanCompareTable.Cell>
  );
};
